import { T, base } from "../lib/theme";

const Input = ({ label, value, onChange, placeholder, type = "text", style: extra = {}, ...props }) => (
  <div style={{ marginBottom: 16 }}>
    {label && (
      <label style={{
        display: "block", fontSize: 11, fontWeight: 600,
        color: T.text2, marginBottom: 6, letterSpacing: "0.02em",
      }}>
        {label}
      </label>
    )}
    <input
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      style={{
        width: "100%", padding: "9px 13px",
        background: T.bg0, border: `1px solid ${T.border2}`,
        borderRadius: 9, color: T.text1, fontSize: 13,
        outline: "none", fontFamily: base.font,
        transition: "border-color 0.18s, box-shadow 0.18s",
        ...extra,
      }}
      onFocus={e => {
        e.target.style.borderColor = T.indigo;
        e.target.style.boxShadow   = `0 0 0 3px ${T.indigoDim}`;
      }}
      onBlur={e  => {
        e.target.style.borderColor = T.border2;
        e.target.style.boxShadow   = "none";
      }}
      {...props}
    />
  </div>
);

export default Input;
